import {
  Component,
  HostListener,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { SubCategoriesService } from '@shared/services/sub-categories.service';
import { FilterFieldService } from '@shared/services/filter_field.service';
import { SubCategory } from '@shared/models/sub-category';
import { Config } from '@core/config';
import { ViewportScroller } from '@angular/common';
import { MatToolbar } from '@angular/material/toolbar';
import { MatDialog } from '@angular/material/dialog';
import { HomeDialogComponent } from '@app/shell/header/home-dialog.component';
import { GAService } from '@app/@shared/services/google-analytics.service';
import { FilterCacheService } from '@app/@shared/components/filters/filter_cache.service';
import { Subscription } from 'rxjs';
import { CardService } from '@app/cards/card.service';
import { CardModel } from '@app/@shared/models/card.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('header') header: MatToolbar;
  @ViewChild('kwDiv') kwDiv: MatToolbar;
  public subCategoriesConfig: any;
  public categoriesConfig: any;
  public hidden: boolean;
  public collapsed: boolean;
  public circuitHidden: boolean;
  public heritageHidden: boolean;
  public sideNavState: boolean;

  // JPP de ce projet.
  public jesuisunevariablemoche?: number;
  private subscriptions: Subscription[];

  public subCategories: SubCategory[];
  public heritageSubCat: SubCategory[];
  public subCat: number;
  public circuit: any[];
  public menu: boolean;
  public title: string[];
  public isMap: boolean;
  public is360: boolean;
  public isInspiration: boolean;
  public isMobile: boolean;
  public currentScreenWidth: number;
  public kwHidden: boolean;
  public kw: string[];
  public kwInput: string;
  public inputWord: string;
  public panoClass: string[];
  public categoriesToShow: any[];
  public currentFilter: string;

  constructor(
    private router: Router,
    private subCategoriesService: SubCategoriesService,
    private filterField: FilterFieldService,
    public viewport: ViewportScroller,
    public dialog: MatDialog,
    public gaService: GAService,
    private filterCacheService: FilterCacheService,
    private cardService: CardService
  ) {
    this.kwHidden = true;
    this.isMobile =
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    this.circuit = Config.circuit;
    this.menu = true;
    this.collapsed = true;
    this.sideNavState = true;
    this.subCategoriesConfig = Config.subCategories;
    this.categoriesConfig = Config.categories;
    this.title = [''];
    this.subscriptions = [];
    this.currentFilter = '';
  }

  async ngOnInit() {
    this.menu = this.router.url === '/';
    const url = this.router.url.split('/');
    this.isMap = url[1] === 'carte' && url.length <= 2;
    this.is360 = url[1] === 'panorama';
    this.isInspiration = url[1] === 'suggestions';

    const resultSubCategService = this.subCategoriesService.getSubCategories();
    this.heritageSubCat = resultSubCategService.subcategories.filter(
      (sc: { parentCategId: number }) => sc.parentCategId === 0
    );
    this.subCategories = resultSubCategService.subcategories;
    this.title = await this.updateTitle(url);

    const routerObserver = {
      next: async () => {
        const route: string = this.router.url;
        const currentUrl = this.router.url.split('/');
        this.menu = route === '/';
        this.isMap = currentUrl[1] === 'carte' && currentUrl.length <= 2;
        this.is360 = currentUrl[1] === 'panorama';
        this.isInspiration =
          currentUrl[1] === 'suggestions' ||
          (currentUrl[1] === 'carte' && currentUrl[2] === '5');
        this.title = await this.updateTitle(currentUrl);
      },
    };
    this.subscriptions.push(this.router.events.subscribe(routerObserver));
    this.subscriptions.push(
      this.filterField.sharedValue$.subscribe(
        (v) => (this.currentFilter = v.filter)
      )
    );

    this.subNavToggle();
    this.onResize();
    if (this.isMobile && window.localStorage.getItem('continue') !== 'true') {
      this.dialog.open(HomeDialogComponent);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) =>
      subscription.unsubscribe()
    );
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (this.viewport.getScrollPosition()[1] > 0) {
      this.header.color = 'warn';
    } else {
      if (this.menu) {
        this.header.color = null;
      }
    }
  }

  /**
   * Set the currentScreenWidth attribute with actual screen width device.
   */
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.currentScreenWidth = this.isMobile
      ? window.screen.width
      : window.innerWidth;
  }

  async updateTitle(url: string[]): Promise<string[]> {
    let title: string[];
    const cat = Object.values(Config.categories).map((c) => c?.name);
    if (url[1] === 'carte') {
      title = [cat[parseInt(url[2], 10)]];
      if (url.length > 3) {
        if (url[2] === '1') {
          title.push(this.getCircuitSubTitle(url));
        } else if (url[2] === '3') {
          if (url[3] === '0') {
            title.push('Ongoing');
          } else if (url[3] === '1') {
            title.push('Forthcoming');
          } else if (url[3] === '2') {
            title.push('Outing');
          }
        } else {
          if (url[3] === '-1') {
            title.push('Insolite');
          } else {
            title.push(
              this.subCategories.find((sc) => sc.id === parseInt(url[3], 10))
                ?.name
            );
          }
        }
      } else if (url[2] === '5') {
        title = ['Suggestions', 'AllSuggestions'];
      } else {
        title.push(`All${cat[parseInt(url[2], 10)]}`);
      }
    } else if (url[1] === 'fiche') {
      let result: CardModel = await this.cardService
        .getCard(url[3])
        .toPromise();
      if (result.subcategory == null) {
        title = [cat[parseInt(url[2])]];
      } else {
        title = [cat[result.category], result.subcategory.name];
      }
    } else if (url[1] === 'suggestions') {
      title = ['Suggestions'];
    } else {
      title = [''];
    }

    // TODO Fix temporaire.
    // On n'a pas la main sur certaines données donc pour en corriger certaines on doit passer par ce genre de modifications.
    // Ceci concerne le titre inscrit sur le header.
    if (title[1] == 'Patrimoine religieux et commemoratif')
      title[1] = 'Patrimoine religieux et commémoratif';
    if (title[1] == 'Activités et Loisirs') title[1] = 'Activités et loisirs';
    if (title[1] == 'Arts et Culture') title[1] = 'Arts et culture';
    if (title[1] == 'Demeures et Châteaux') title[1] = 'Demeures et châteaux';
    if (title[1] == 'Hébergement') title[1] = 'Hébergements';

    return title;
  }

  private getCircuitSubTitle(url: string[]): string {
    return Object.values(Config.circuit).find(
      (elem) => elem.id == parseInt(url[3], 10)
    )?.name;
  }

  subNavToggle(cat?: number): void {
    if (cat === 1 && this.circuitHidden) {
      this.circuitHidden = false;
      this.heritageHidden = true;
      this.hidden = false;
      this.jesuisunevariablemoche = 1;
    } else if (cat === 0 && this.heritageHidden) {
      this.circuitHidden = true;
      this.heritageHidden = false;
      this.hidden = false;
      this.jesuisunevariablemoche = 0;
    } else {
      this.circuitHidden = true;
      this.heritageHidden = true;
      this.hidden = true;
    }
  }

  subNavClose() {
    this.subNavToggle();
    this.collapsed = false;
  }

  swapToSubNav(): void {
    this.collapsed = !this.collapsed;
  }

  toggleSideNav() {
    this.sideNavState = !this.sideNavState;
  }

  closeSideNav() {
    this.sideNavState = true;
    this.subNavClose();
  }

  updateKeyWords(kw: string[]) {
    this.kwHidden = false;
    this.kw = kw;
  }

  hideKw(hide: boolean) {
    this.kwHidden = hide;
  }

  containsCat(cat: string) {
    return this.inputWord?.toLowerCase().includes(cat);
  }

  updateCategories(inputWord: string) {
    this.categoriesToShow = [];
    const input = this.normalize(inputWord);
    for (const category of categories) {
      if (
        this.categoriesToShow.length < 5 &&
        category['tags'].some((t: any) => this.normalize(t).includes(input))
      ) {
        this.categoriesToShow.push(category);
      }
    }
  }

  normalize(text: string) {
    return text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase();
  }

  setInput(input: string) {
    this.inputWord = input;
    this.updateCategories(this.inputWord);
  }

  /**
   * On utilise ce genre de fonction car nous n'avons pas la main sur certaines data dont les label de subcateg.
   * Ceci nous permet de corriger les données (orthographes, etc)..
   * Cette fonction concerne le burger menu.
   * TODO Fix temporaire pour changer le string d'une des categ laquelle une faute orthographique est à signaler.
   * @param {SubCategory} cat
   */
  public displaySubCategName(cat: SubCategory, mainCat: number): string {
    if (mainCat == 0 && cat.id == 1) return 'Arts et culture';
    if (mainCat == 0 && cat.id == 6)
      return 'Patrimoine religieux et commémoratif';
    if (mainCat == 0 && cat.id == 14) return 'Hébergements';
    if (mainCat == 0 && cat.id == 19) return 'Demeures et châteaux';
    return cat.name;
  }

  public isIphone(): boolean {
    return /iPhone/i.test(navigator.userAgent);
  }

  /**
   * Send event on main categ click.
   * @param {string} eventName
   */
  public sendCategGaEvent(event: string): void {
    this.filterCacheService.resetStoredValues();
    this.gaService.sendEvent(event, 'Categorie');
  }

  /**
   * Send event on subcateg click.
   * @param {string} eventName
   */
  public sendSubcategGaEvent(event: string): void {
    this.filterCacheService.resetStoredValues();
    if (event == 'Walk') event = 'A pied';
    if (event == 'MountainBike') event = 'A vélo - VTT';
    if (event == 'HybridBike') event = 'A vélo - VTC';
    if (event == 'Bike') event = 'A vélo - sur route';
    if (event == 'Horse') event = 'A cheval';
    if (event == 'Trail') event = 'Trail';
    this.gaService.sendEvent(event, 'Sous-catégorie');
  }

  /**
   * Genral method to send GA.
   * @param {string} event
   * @param {string} categorie
   */
  public sendGaEvent(event: string, categorie?: string, label?: string): void {
    this.gaService.sendEvent(event, categorie, label);
  }
}

const categories = [
  {
    name: 'Circuit',
    routerLink: '/carte/1',
    tags: [
      'circuit',
      'circuits',
      'balade',
      'itinéraire',
      'boucle',
      'randonnée',
      'sport',
      'balades',
      'itinéraires',
      'boucles',
      'randonnées',
      'sports',
    ],
  },
  {
    name: 'À pied',
    routerLink: '/carte/1/1',
    tags: ['marche', 'pédestre', 'randonnée', 'marcher', 'randonnées'],
  },
  {
    name: 'À vélo - VTT',
    routerLink: '/carte/1/2',
    tags: ['vtt', 'vélo', 'pédaler', 'vélos'],
  },
  {
    name: 'À vélo - VTC',
    routerLink: '/carte/1/4',
    tags: ['vtc', 'vélo', 'pédaler', 'vélos'],
  },
  {
    name: 'À vélo - sur route',
    routerLink: '/carte/1/8',
    tags: ['vélo', 'cycle', 'cyclo', 'pédaler', 'vélos', 'cycles', 'cyclos'],
  },
  {
    name: 'À Cheval',
    routerLink: '/carte/1/16',
    tags: ['cheval', 'chevaux', 'équitation', 'équestre', 'monter à cheval'],
  },
  {
    name: 'Trail',
    routerLink: '/carte/1/32',
    tags: ['trail', 'trails', 'course à pied', 'running', 'courir'],
  },
  {
    name: 'Patrimoine',
    routerLink: '/carte/0',
    tags: [
      'patrimoine',
      'monument historique',
      'patrimoines',
      'monuments historiques',
    ],
  },
  {
    name: 'Service',
    routerLink: '/carte/2',
    tags: ['service', 'services', 'sortie', 'quoi faire', 'sorties'],
  },
  {
    name: 'Agenda',
    routerLink: '/carte/3',
    tags: [
      'agenda',
      'sortie',
      'evenement',
      'quoi faire',
      'sorties',
      'evenements',
    ],
  },
  {
    name: 'Archéologie',
    routerLink: '/carte/0/0',
    tags: [
      'archeologie',
      'archéo',
      'archeologique',
      'histoire',
      'historique',
      'dolmen',
      'menhir',
      'histoires',
      'historiques',
      'dolmens',
      'menhirs',
      'site disparu',
      'sites disparus',
      'vestige archeologique',
      'vestiges archeologiques',
      'megalithe',
      'megalithes',
    ],
  },
  {
    name: 'Arts et Culture',
    routerLink: '/carte/0/1',
    tags: [
      'art et culture',
      'personnages',
      'artistes',
      'célébrités',
      'cinémas',
      'films',
      'séries',
      'oeuvres',
      'street art',
      'graffitis',
    ],
  },
  {
    name: 'Demeures et Châteaux',
    routerLink: '/carte/0/19',
    tags: [
      'demeures et chateaux',
      'donjons',
      'chateaux',
      'grandes demeures ou manoirs',
      'maisons remarquables',
    ],
  },
  {
    name: 'Architectures publiques',
    routerLink: '/carte/0/3',
    tags: [
      'demeures et chateaux',
      'bâtiments',
      'routes',
      'trains',
      'transports',
      'gares',
      'forts',
      'hopital',
      'hopitaux',
      'hospices',
      'gibets',
      'tribunal',
      'tribunaux',
      'Postes et télécommunications',
      'Mairies écoles',
      'Bains douches',
      'Places et quartiers',
      'Patrimoine routier et ferroviaire',
      'Patrimoine militaire',
      'Patrimoine hospitalier',
      'Lieux de justice',
    ],
  },
  {
    name: 'Patrimoine religieux et commémoratif',
    routerLink: '/carte/0/6',
    tags: [
      'Patrimoine religieux et commémoratif',
      'religions',
      'sorties',
      'cimétières',
      'tombes',
      'monument aux morts',
      'Lieux de culte',
      'Croix pattée',
      'Croix',
      'Abbayes et prieurés',
      'Sépultures remarquables',
      'Monuments commémoratifs',
    ],
  },
  {
    name: 'Patrimoine industriel et commercial',
    routerLink: '/carte/0/18',
    tags: [
      'Patrimoine industriel et commercial',
      'Moulins',
      'Usines et fabriques',
      'Commerces anciens',
    ],
  },
  {
    name: 'Patrimoine agricole',
    routerLink: '/carte/0/4',
    tags: [
      'Patrimoine agricole',
      'exploitation',
      'Granges',
      'Pigeonniers',
      'Fermes',
    ],
  },
  {
    name: "Autour de l'eau",
    routerLink: '/carte/0/5',
    tags: [
      "Autour de l'eau",
      'Lavoirs',
      'Fontaines',
      'Abreuvoirs',
      'Puits',
      'Moulins à eau',
      'Plages et baignades',
    ],
  },
  {
    name: 'Nature',
    routerLink: '/carte/0/2',
    tags: [
      'Nature',
      'Parcs et jardins',
      'Arbres remarquables',
      'Espaces naturels et forêts',
      'Points de vue et panoramas',
      'fleurs',
      'paysages',
    ],
  },
  {
    name: 'Insolite',
    routerLink: '/carte/0/-1',
    tags: ['Insolite'],
  },
  {
    name: 'Hébergements',
    routerLink: '/carte/2/14',
    tags: [
      'hébergements',
      'gîtes',
      'chambres',
      'locations',
      'dormir',
      'hôtels',
    ],
  },
  {
    name: 'Restaurants',
    routerLink: '/carte/2/15',
    tags: ['Restaurants', 'tables', 'manger'],
  },
  {
    name: 'Commerces et services',
    routerLink: '/carte/2/35',
    tags: [
      'Commerces et services',
      'boutiques',
      'locations',
      'loueurs',
      'acheter',
    ],
  },
  {
    name: 'Informations touristiques',
    routerLink: '/carte/2/36',
    tags: [
      'Informations touristiques',
      'office de tourisme',
      'bureaux',
      'se renseigner',
      'renseignements',
    ],
  },
  {
    name: 'Activités et loisirs',
    routerLink: '/carte/2/37',
    tags: [
      'Activités et loisirs',
      'guides',
      'accompagnements',
      'ateliers',
      'sports',
      'divertissements',
    ],
  },
  {
    name: 'Producteurs locaux',
    routerLink: '/carte/2/38',
    tags: [
      'Producteurs locaux',
      'guides',
      'accompagnements',
      'ateliers',
      'sports',
      'divertissements',
    ],
  },
  {
    name: 'Sorties nature',
    routerLink: '/carte/3/2',
    tags: ['Sorties nature', 'sortir'],
  },
  {
    name: 'Jeux',
    routerLink: '/carte/4',
    tags: ['Jeux', 'divertissements', 'ludiques', 'quizz', 'geocaching'],
  },
  {
    name: 'Actuellement',
    routerLink: '/carte/3/0',
    tags: ['Actuellement'],
  },
  {
    name: 'À venir',
    routerLink: '/carte/3/1',
    tags: ['À venir'],
  },
  {
    name: 'Sites disparus',
    routerLink: '/carte/0/0',
    queryParams: { filter: 'Sites disparus' },
    tags: ['Sites disparus'],
  },
  {
    name: 'Vestiges archéologiques',
    routerLink: '/carte/0/0',
    queryParams: { filter: 'Vestiges archéologiques' },
    tags: ['Vestiges archéologiques'],
  },
  {
    name: 'Mégalithes',
    routerLink: '/carte/0/0',
    queryParams: { filter: 'Mégalithes' },
    tags: ['Mégalithes', 'dolmens', 'menhirs'],
  },

  {
    name: 'Personnes illustres',
    routerLink: '/carte/0/1',
    queryParams: { filter: 'Personnes illustres' },
    tags: ['Personnes illustres', 'personnages', 'artistes', 'célébrités'],
  },
  {
    name: 'Lieux de tournage',
    routerLink: '/carte/0/1',
    queryParams: { filter: 'Lieux de tournage' },
    tags: ['Lieux de tournage', 'cinémas', 'films', 'séries'],
  },
  {
    name: 'Musées',
    routerLink: '/carte/0/1',
    queryParams: { filter: 'Musées' },
    tags: ['Musées', 'oeuvres'],
  },
  {
    name: 'Arts urbains',
    routerLink: '/carte/0/1',
    queryParams: { filter: 'Arts urbains' },
    tags: ['Arts urbains', 'street art', 'graffitis'],
  },
  {
    name: 'Sculptures et œuvres monumentales',
    routerLink: '/carte/0/1',
    queryParams: { filter: 'Sculptures et œuvres monumentales' },
    tags: ['Sculptures et œuvres monumentales'],
  },
  {
    name: 'Théâtres et cinémas remarquables',
    routerLink: '/carte/0/1',
    queryParams: { filter: 'Théâtres et cinémas remarquables' },
    tags: ['Théâtres et cinémas remarquables'],
  },
  {
    name: 'Châteaux',
    routerLink: '/carte/0/2',
    queryParams: { filter: 'Châteaux' },
    tags: ['Châteaux', 'donjons'],
  },
  {
    name: 'Grandes demeures ou manoirs',
    routerLink: '/carte/0/2',
    queryParams: { filter: 'Grandes demeures ou manoirs' },
    tags: ['Grandes demeures ou manoirs'],
  },
  {
    name: 'Maisons remarquables',
    routerLink: '/carte/0/2',
    queryParams: { filter: 'Maisons remarquables' },
    tags: ['Maisons remarquables'],
  },
  {
    name: 'Postes et télécommunications',
    routerLink: '/carte/0/3',
    queryParams: { filter: 'Postes et télécommunications' },
    tags: ['Postes et télécommunications'],
  },
  {
    name: 'Mairies écoles',
    routerLink: '/carte/0/3',
    queryParams: { filter: 'Mairies écoles' },
    tags: ['Mairies écoles'],
  },
  {
    name: 'Places et quartiers',
    routerLink: '/carte/0/3',
    queryParams: { filter: 'Places et quartiers' },
    tags: ['Places et quartiers'],
  },
  {
    name: 'Bains douches',
    routerLink: '/carte/0/3',
    queryParams: { filter: 'Bains douches' },
    tags: ['Bains douches'],
  },
  {
    name: 'Patrimoine routier et ferroviaire',
    routerLink: '/carte/0/3',
    queryParams: { filter: 'Patrimoine routier et ferroviaire' },
    tags: [
      'Patrimoine routier et ferroviaire ',
      'routes',
      'trains',
      'transports',
      'gares',
    ],
  },
  {
    name: 'Patrimoine militaire',
    routerLink: '/carte/0/3',
    queryParams: { filter: 'Patrimoine militaire' },
    tags: ['Patrimoine militaire', 'forts'],
  },
  {
    name: 'Patrimoine hospitalier',
    routerLink: '/carte/0/3',
    queryParams: { filter: 'Patrimoine hospitalier' },
    tags: ['Patrimoine hospitalier', 'hopital', 'hopitaux', 'hospices'],
  },
  {
    name: 'Lieux de justice',
    routerLink: '/carte/0/3',
    queryParams: { filter: 'Lieux de justice' },
    tags: ['Lieux de justice', 'gibets', 'tribunal', 'tribunaux'],
  },
  {
    name: 'Lieux de culte',
    routerLink: '/carte/0/6',
    queryParams: { filter: 'Lieux de culte' },
    tags: ['Lieux de culte'],
  },
  {
    name: 'Croix pattée',
    routerLink: '/carte/0/6',
    queryParams: { filter: 'Croix pattée' },
    tags: ['Croix pattée'],
  },
  {
    name: 'Croix',
    routerLink: '/carte/0/6',
    queryParams: { filter: 'Croix' },
    tags: ['Croix'],
  },
  {
    name: 'Abbayes et prieurés',
    routerLink: '/carte/0/6',
    queryParams: { filter: 'Abbayes et prieurés' },
    tags: ['Abbayes et prieurés'],
  },
  {
    name: 'Sépultures remarquables',
    routerLink: '/carte/0/6',
    queryParams: { filter: 'Sépultures remarquables' },
    tags: ['Sépultures remarquables', 'cimetières', 'tombes'],
  },
  {
    name: 'Monuments commémoratifs',
    routerLink: '/carte/0/6',
    queryParams: { filter: 'Monuments commémoratifs' },
    tags: [
      'Monuments commémoratifs',
      'monument aux morts',
      'monuments aux morts',
    ],
  },
  {
    name: 'Moulins',
    routerLink: '/carte/0/18',
    queryParams: { filter: 'Moulins' },
    tags: ['Moulins'],
  },
  {
    name: 'Usines et fabriques',
    routerLink: '/carte/0/18',
    queryParams: { filter: 'Usines et fabriques' },
    tags: ['Usines et fabriques'],
  },
  {
    name: 'Commerces anciens',
    routerLink: '/carte/0/18',
    queryParams: { filter: 'Commerces anciens' },
    tags: ['Commerces anciens'],
  },
  {
    name: 'Granges',
    routerLink: '/carte/0/4',
    queryParams: { filter: 'Granges' },
    tags: ['Granges'],
  },
  {
    name: 'Pigeonniers',
    routerLink: '/carte/0/4',
    queryParams: { filter: 'Pigeonniers' },
    tags: ['Pigeonniers'],
  },
  {
    name: 'Fermes',
    routerLink: '/carte/0/4',
    queryParams: { filter: 'Fermes' },
    tags: ['Fermes', 'exploitations'],
  },
  {
    name: 'Lavoirs',
    routerLink: '/carte/0/5',
    queryParams: { filter: 'Lavoirs' },
    tags: ['Lavoirs'],
  },
  {
    name: 'Fontaines',
    routerLink: '/carte/0/5',
    queryParams: { filter: 'Fontaines' },
    tags: ['Fontaines'],
  },
  {
    name: 'Abreuvoirs',
    routerLink: '/carte/0/5',
    queryParams: { filter: 'Abreuvoirs' },
    tags: ['Abreuvoirs'],
  },
  {
    name: 'Puits',
    routerLink: '/carte/0/5',
    queryParams: { filter: 'Puits' },
    tags: ['Puits'],
  },
  {
    name: 'Moulins à eau',
    routerLink: '/carte/0/5',
    queryParams: { filter: 'Moulins à eau' },
    tags: ['Moulins à eau'],
  },
  {
    name: 'Plages et baignades',
    routerLink: '/carte/0/5',
    queryParams: { filter: 'Moulins à eau' },
    tags: ['Plages et baignades'],
  },
  {
    name: 'Parcs et jardins',
    routerLink: '/carte/0/2',
    queryParams: { filter: 'Parcs et jardins' },
    tags: ['Parcs et jardins', 'fleurs'],
  },
  {
    name: 'Arbres remarquables',
    routerLink: '/carte/0/2',
    queryParams: { filter: 'Arbres remarquables' },
    tags: ['Arbres remarquables'],
  },
  {
    name: 'Espaces naturels et forêts',
    routerLink: '/carte/0/2',
    queryParams: { filter: 'Espaces naturels et forêts' },
    tags: ['Espaces naturels et forêts'],
  },
  {
    name: 'Points de vue et panoramas',
    routerLink: '/carte/0/2',
    queryParams: { filter: 'Points de vue et panoramas' },
    tags: ['Points de vue et panoramas', 'paysages'],
  },
];
